<template>
  <div class="moderations">
    <v-container fluid class="pt-0">
      <v-row class="mb-2 py-0">
        <v-col cols="12" sm="4" md="3" lg="2" class="nav-left pb-10 pt-0 px-0 d-none d-sm-block">
          <SideMenu />
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right px-3 py-10 pl-sm-14 mt-10">
          <v-parallax height="auto" src="@/assets/images/back-page.webp">
            <v-row justify="center">
              <v-col xl="10" lg="10" md="12">
                <v-card class="pt-0 d-flex justify-space-between mx-auto rounded-lg back-color">
                  <v-card-title class="text-h4 py-5 font-weight-bold">
                    <span class="blue--text text--light-blue text--darken-4 pr-1">¡Hola</span>
                    <span class="white--text">{{ getUser.firstName || "Super Administrador" }}!</span>
                  </v-card-title>
                  <v-col cols="5" class="d-flex align-center" v-if="getUser.role === 'sysadmin'">
                    <v-text-field
                      label="Buscar"
                      v-model="searchText"
                      @input="searchKeyInput()"
                      prepend-inner-icon="mdi-magnify"
                      color="info"
                      class="mb-0 pa-0 search-input"
                      hide-details="auto"
                      :loading="loading"
                      loader-height="5"
                      solo
                      clearable
                    >
                    </v-text-field>
                  </v-col>
                </v-card>
              </v-col>
              <v-col cols="12" lg="10">
                <!-- Tabs -->
                <v-tabs v-model="tab" grow>
                  <v-tabs-slider class="dashboard-tab__slider" color="#3badff"></v-tabs-slider>
                  <v-tab
                    class="dashboard-tab rounded-tl-lg"
                    href="#open-offers"
                    @click="changeTab('review')"
                  >
                    <div :class="`dashboard-tab__front${page.tab === 'review' ? '--active' : ''} rounded-t-lg`">
                      <span :class="`dashboard-tab__title${page.tab === 'review' ? '--active' : ''}`">RECIBIDAS</span>
                    </div>
                  </v-tab>
                  <v-tab
                   class="dashboard-tab rounded-tr-lg"
                   href="#close-offers"
                   @click="changeTab('failed')"
                  >
                    <span :class="`dashboard-tab__front${page.tab === 'failed' ? '--active' : ''} rounded-t-lg`">
                      <span :class="`dashboard-tab__title${page.tab === 'failed' ? '--active' : ''}`">MODERADAS</span>
                    </span>
                  </v-tab>
                </v-tabs>

                <!-- Tab content -->
                <!-- TODO: Extraer y unificar Review Tab y Failed Tab en un componente -->
                <v-tabs-items touchless v-model="tab">
                  <!-- Loader -->
                  <v-tab-item :value="tab">
                    <v-card
                      v-if="!page[page.tab].data.length"
                      elevation="0"
                      justify="center"
                      class="dashboard-tab__loader d-flex justify-center"
                      :loading="loading"
                    >
                      <v-row align="center">
                        <v-col class="py-16 text-center">
                          <v-icon color="white" size="75">{{`mdi-file`}}</v-icon>
                          <h2 v-if="!loading" class="my-5">{{emptyOffer}}</h2>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <!-- Review Tab -->
                  <v-tab-item class="moderations__tab-item" id="open-offers" value="tab">
                    <!-- Moderation Cards [Review] -->
                    <v-container
                      v-for="item in page.review.data"
                      :key="item.id"
                      class="moderations__background"
                    >
                      <v-card
                        class="moderation-card"
                        elevation="0"
                        rounded="4"
                      >
                        <!-- Avatar  -->
                        <v-avatar class="moderation-card__avatar" size="80">
                          <v-img :src="getAvatarPath(item)" />
                        </v-avatar>

                        <!-- Moderation Card Left -->
                        <div class="moderation-card__left">
                          <h3 class="moderation-card__title">{{ item.title }}</h3>
                          <span class="moderation-card__text">
                            {{ formatterDate(item.moderatedAt ? item.moderatedAt : item.createdAt) }}
                          </span>
                          <div class="d-flex flex-row align-center">
                            <span class="moderation-card__label">
                              MODERACIÓN
                            </span>
                            <v-select
                              grow
                              class="mod-card-content__select"
                              loading="true"
                              item-color="primary"
                              :items="moderations"
                              dense
                              solo
                              hide-details
                              @change="(value) => { selected({ newStatus: value, item, }); }"
                            >
                              <template v-slot:label >
                                <span style="color: #3badff; font-family: 'Circular';">EN PROCESO</span>
                              </template>
                              <template v-slot:selection="{ item }">
                                <span style="color: #3badff; font-family: 'Circular';">{{ item }}</span>
                              </template>
                              <template v-slot:item="{ item }">
                                <span style="color: #3badff; font-family: 'Circular';">{{ item }}</span>
                              </template>
                            </v-select>
                          </div>
                        </div>

                        <!-- Moderation Card Right -->
                        <div class="moderation-card__right">
                          <span class="moderation-card__payment">
                            <span class="moderation-card__text">Estado de pago</span>
                            <span
                              class="moderation-card__indicator"
                              :class="item.tabulated ? 'moderation-card__indicator--off' : 'moderation-card__indicator--failure'"
                            ></span>
                            <span
                              class="moderation-card__indicator"
                              :class="item.tabulated ? ' moderation-card__indicator--approved' : 'moderation-card__indicator--off'"
                            ></span>
                          </span>
                          <v-btn class="moderation-card__text px-0" text @click="copyEmail(item)">
                            {{ item.user && item.user.email || "correo@correo.cl" }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <OfferPreview :offer="item" type="moderation" />
                        </div>
                      </v-card>
                    </v-container>

                    <v-pagination
                      v-show="page.review.data.length >= 10"
                      v-model="page.review.index"
                      :length="6"
                      @input="changePage"
                    ></v-pagination>
                  </v-tab-item>

                  <!-- Failed Tab -->
                  <v-tab-item id="close-offers" value="tab">
                    <!-- Moderation Cards [Failed] -->
                    <v-container
                      class="moderations__background"
                      v-for="item in page.failed.data"
                      :key="item.id"
                    >
                      <v-card
                        class="moderation-card"
                        elevation="0"
                        rounded="4"
                      >
                        <v-avatar class="moderation-card__avatar" size="80">
                          <v-img :src="getLogo(item)" />
                        </v-avatar>

                        <div class="moderation-card__left">
                          <h3 class="moderation-card__title">{{ item.title}}</h3>
                          <span class="moderation-card__text">
                            {{ formatterDate(item.moderatedAt ? item.moderatedAt : item.createdAt) }}
                          </span>
                        </div>

                        <div class="moderation-card__right">
                          <v-chip
                            class="moderation-card__chip"
                            :color="item.status === 'open' ? 'success' : 'error'"
                          >
                            {{ item.status === 'open' ? 'ABIERTA' : 'CON OBSERVACIONES' }}
                          </v-chip>
                          <OfferPreview :offer="item" context="moderation" />
                        </div>
                      </v-card>
                    </v-container>


                    <v-pagination
                      v-show="page.failed.data.length >= 10"
                      v-model="page.failed.index"
                      :length="6"
                      @input="changePage"
                    ></v-pagination>
                  </v-tab-item>
                </v-tabs-items>

              </v-col>
            </v-row>
          </v-parallax>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar.status"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{snackbar.text}}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.status = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu";
import OfferPreview from "@/components/OfferPreview";
import { userComputed } from "@/store/helpers.js";
import { currentImg, datetime, meta } from "@/libs/mixins";

export default {
    name: "Moderations",

    components: {
        SideMenu,
        OfferPreview,
    },

    mixins: [currentImg, datetime, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Moderación",
        });
    }, 

    props: ["user", "reviewOffers", "failedOffers"],

    data() {
        return {
            moderations: [
                "EN PROCESO",
                "CON OBSERVACIONES",
                "APROBADA"
            ],
            tab: "",
            selecSatus: [
                { label: "EN PROCESO", status: "review" },
                { label: "CON OBSERVACIONES", status: "failed" },
                { label: "APROBADA", status: "open" },
            ],
            review: [],
            obs: [],
            page: {
                tab: "review",
                review: {
                    index: 1,
                    data: [],
                    total: 0
                },
                failed: {
                    index: 1,
                    data: [],
                    total: 0
                }
            },

            /// propiedades de busqueda de ofertas ///
            timerId: null,
            searchText: "",
            searchedText: "",

            emptyOffer: "Aún no tienes publicaciones para moderar o moderadas",
            dialogOffer: null,
            dialogSlug: "",
            dialogTitle: "",
            loading: true,
            dialog: false,
            snackbar: {
                status: false,
                text: "",
                timeout: 2000,
                color: "success",
            },
        };
    },

    created() {
        this.reload(this.page.tab, 1);

        if (this.page.review.dataOffers) {
            this.page.review.data = this.page.review.dataOffers.sort((a, b) => {
                let dateA = new Date(a.createdAt);
                let dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
        } else {
            this.page.review.data = [];
        }

        if (this.page.failed.dataOffers) {
            this.page.failed.data = this.page.failed.dataOffers.sort((a, b) => {
                let dateA = new Date(a.createdAt);
                let dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
        } else {
            this.page.failed.data = [];
        }
    },

    computed: {
        ...userComputed,
        pagesReview() {
            return Math.ceil(this.page.review.total / parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE));
        },
        pagesFailed() {
            return Math.ceil(this.page.failed.total / parseInt(process.env.VUE_APP_DASHBOARD_OFFERS_PAGE_SIZE));
        }
    },

    methods: {
        changePage(page) {
            this.reload(this.page.tab, page);
        },
        changeTab(tab) {
            this.page.tab = tab;
            this.reload(tab, this.page[tab].index);
        },
        copyEmail(value) {
            if (value.user.email) {
                const el = document.createElement("textarea");
                el.value = value.user.email || "Este usuario no tiene el correo asignado";
                el.setAttribute("readonly", "");
                el.style.position = "absolute";
                el.style.left = "-9999px";
                document.body.appendChild(el);
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);
                this.snackbar.text = "Se copio el correo: " + (value.user.email || "Este usuario no tiene el correo asignado");
                this.snackbar.color = "success";
                this.snackbar.status = true;
            } else {
                this.snackbar.text = "No se logro copiar el correo, es probable que el usuario no lo tenga registrado";
                this.snackbar.color = "error";
                this.snackbar.status = true;
            }
        },
        getOfferFiltered() {
        },
        open(offer) {
            this.dialogOffer = offer;
            this.dialog = true;
        },
        searchKeyInput() {
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                this.searchOffer();
            }, process.env.VUE_APP_SEARCH_TIMEOUT);
        },
        searchOffer() {
            if (this.searchedText != this.searchText) {
                this.page.tab = "review";
                this.reload(this.page.tab, 1);
                this.searchedText = this.searchText;
            }
        },
        reload(tab, page) {
            this.loading = true;
            this.page[this.page.tab].data = [];

            let parameters = {
                page: page
            };

            if (this.searchText) {
                parameters.tags = this.searchText.replace(/ /g, ",");
            }

            this.$store.dispatch("offers/" + tab, parameters).then((content) => {
                this.loading = false;
                this.page[this.page.tab].data = content.offers;
                this.page[this.page.tab].total = content.total;
            }).catch((e) => {
                this.loading = false;
            });
        },
        selected(value) {
            this.loading = true;
            const object = {};

            if (value.newStatus === "EN PROCESO") {
                console.warn("The status was not changed.");
            } else if (value.newStatus === "CON OBSERVACIONES") {
                object.organizationId = value.item.organization.id;
                object.offer = { id: value.item.id, status: "failed" };
                let selected = this.page.review.data.findIndex(i => i.id === value.item.id);
                this.$store.dispatch("offers/update", object).then(() => {
                    this.page.review.data[selected].status = "failed";
                    this.page.failed.data.unshift(this.page.review.data[selected]);
                    this.page.review.data.splice(selected, 1);
                    this.loading = false;
                }).catch(err => {
                    console.error(err);
                    this.loading = false;
                });

            } else if (value.newStatus === "APROBADA") {
                object.organizationId = value.item.organization.id;
                object.offer = { id: value.item.id, status: "open" };
                let selected = this.page.review.data.findIndex(i => i.id === value.item.id);
                this.$store.dispatch("offers/update", object).then(() => {
                    this.page.review.data[selected].status = "open";
                    this.page.review.data.splice(selected, 1);
                    this.loading = false;
                }).catch(err => {
                    console.error(err);
                    this.loading = false;
                });
            } else {
                console.warn("Don't exist status");
            }
        }
    },
};
</script>

<style scoped>
#padding-top {
    padding-top: 90px;
}
.opacity {
    opacity: 0.6;
    background: #ffffff;
}
input.search-input label {
    top: 0;
}
.label-span {
    color: #3badff;
    font-size: 1rem;
}
.title-tab {
    color: #3d52a0;
}
.select-moderations {
    color: #3badff;
}
</style>
